'use client';

import debounce from 'lodash.debounce';
import { useEffect, useState } from 'react';

import { LocationDto } from '@/lib/locations';
import { getGoogleMapsDirectionUrl } from '@/models/location-utils';

import StaticHeader from './StaticHeader';
import StickyHeader from './StickyHeader';

import clsx from 'clsx';

type LocationHeaderProps = {
  location: LocationDto;
};

export default function LocationHeader({ location }: LocationHeaderProps) {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = debounce(() => {
      const scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop > 60) {
        setIsSticky((prev) => (prev !== true ? true : prev));
      } else {
        setIsSticky((prev) => (prev !== false ? false : prev));
      }
    }, 50);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const directionUrl = getGoogleMapsDirectionUrl({
    city: location.city,
    address: location.address,
    brandName: location.brandName,
    name: location.name,
    state: location.state,
    zipCode: location.zipCode,
  });

  return (
    <header>
      <StaticHeader
        className={clsx('transition-all', isSticky && 'lg:opacity-0')}
        location={location}
        directionUrl={directionUrl}
      />
      <StickyHeader
        className={clsx('max-lg:hidden', !isSticky && 'hidden')}
        location={location}
        directionUrl={directionUrl}
      />
    </header>
  );
}
